import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Calcula streak (sequência de dias consecutivos) a partir de hoje
 * @param sortedDates Array de datas em formato ISO, ordenadas
 * @returns Número de dias consecutivos desde hoje
 */
export function calculateStreak(sortedDates: string[]): number {
  if (sortedDates.length === 0) return 0;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  let streak = 0;
  let currentDate = new Date(today);

  // Iterar do mais recente para o mais antigo
  for (let i = sortedDates.length - 1; i >= 0; i--) {
    const dateStr = sortedDates[i];
    const checkDate = new Date(dateStr);
    checkDate.setHours(0, 0, 0, 0);

    // Se a data atual do loop corresponde à data esperada
    if (checkDate.getTime() === currentDate.getTime()) {
      streak++;
      currentDate.setDate(currentDate.getDate() - 1);  // Voltar 1 dia
    } else {
      break;  // Sequência quebrada
    }
  }

  return streak;
}
